'use client';

import React from 'react';
import {useCommonData} from '@udemy-v2/common-data';
import {InDemandCareerWrapper, type InDemandCareer} from '@udemy-v2/career-accelerators';

import type {Academy} from '../../data/types';

interface CareerAcademiesProps {
    data: Academy[] | null;
}

const toInDemandCareer = (academy: Academy, isUSMarketplace: boolean): InDemandCareer => ({
    slug: academy.slug,
    title: academy.title,
    imageUrl: academy.image,
    averageRating: academy.avg_rating,
    numberOfRatings: academy.num_reviews,
    totalHours: academy.total_hours,
    averageSalary: isUSMarketplace ? academy.average_salary : undefined,
    openRoles: isUSMarketplace ? academy.open_roles : undefined,
});

export const CareerAcademies: React.FC<CareerAcademiesProps> = ({data}) => {
    const {visitor} = useCommonData();
    const isUSMarketplace = visitor.countryCode === 'US';

    if (!data || !data.length) return null;

    const parsedCareerData = data.map((academy) => toInDemandCareer(academy, isUSMarketplace));

    return <InDemandCareerWrapper careers={parsedCareerData} />;
};
